import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';

import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CKEditor from "ckeditor4-react";
CKEditor.editorUrl = "../../assets/ckeditor/ckeditor.js";



const TopicProp = forwardRef((props, ref) => {

    //#region const 

    let navigate = useNavigate();
    const [Id, setId] = useState(General.GuidEmpty());
    const [Title, setTitle] = useState("");
    const [Order, setOrder] = useState(0);
    const [Content, setContent] = useState('');
    const [IsActive, setIsActive] = useState(true);
    const [KeyWords, setKeyWords] = useState('');
    const [ShowLoader, setShowLoader] = useState(false);
    const [ProjectId, setProjectId] = useState(General.GuidEmpty());
    const [ParentId, setParentId] = useState(General.GuidEmpty());
    const [Comment, setComment] = useState("");
    const [URLs, setURLs] = useState([]);
    const [URL, setURL] = useState("");
    const [Code,setCode]=useState("");
    const quillRef = React.useRef();
    //#endregion

    //#region Methods 



    function Content_Change(e) {
        setContent(e.editor.getData());
    }

    useImperativeHandle(ref, () => ({
        ShowEdit(Id) {
            if (Id != undefined)
                setId(Id);
        },
        SetProjectParent(ProjectId, ParentId) {
            setProjectId(ProjectId);
            setParentId(ParentId);
        }
    }))


    const Reset=()=>{
        setCode("");
        setOrder(0);
        setTitle("");
        setKeyWords("");
        setComment("");
        setContent("");
        setURLs([]);
        setId(General.GuidEmpty());
        setIsActive(true);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Title === "") {
            General.ShowMsg(Enum.MsgType.error, "عنوان را مشخص نمایید");
            return;
        }

        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/Topic/Save',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "Title": Title,
                "ProjectId": ProjectId,
                "Order": Order,
                "IsActive": IsActive ? 1 : 0,
                "KeyWords": KeyWords,
                "Content": Content,
                "ParentId": ParentId,
                "TopicURL": URLs,
                "Comment": Comment
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    if (res.data.isSuccess) {

                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                        Reset();
                        setShowLoader(false);

                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                        setShowLoader(false);
                    }

                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                        setShowLoader(false);
                    }
                })
        )
    };

    const Bind = () => {
        setShowLoader(true);
        var RequestOption = {
            mthod: 'Get',
            url: General.ApiRoute() + "/Topic/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            }
            , withCredentials: true


        }

        axios(RequestOption)
            .then(function (res) {
                setTitle(res.data.title);
                setKeyWords(res.data.keyWords);
                setParentId(res.data.parentId);
                setProjectId(res.data.projectId);
                setContent(res.data.content);
                setComment(res.data.comment);
                setURLs(res.data.topicURL);
                setOrder(res.data.order);
                setCode(res.data.code);
                setShowLoader(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    const AddURL = () => {
        const NewURL = {
            url: URL,
            id: General.GuidEmpty(),
            topicId: General.GuidEmpty
        }
        setURLs(prev => [...prev, NewURL]);
    }

    const DeleteURL = (url) => {
        var tmp = [...URLs];
        tmp.splice(tmp.indexOf(url), 1);
        setURLs(tmp);
    }

    useEffect(() => {
        if (Id != General.GuidEmpty())
            Bind();
    }, [Id])
    //#endregion


    return (
        <form onSubmit={handleSubmit}>
            <div>
                <h3>
                    {Code}
                </h3>
            </div>
            <div>
                <rsuite.Checkbox checked={IsActive} onClick={() => setIsActive(!IsActive)} /> فعال می باشد
            </div>
            <div>
                <label>شماره ترتیب</label>
                <rsuite.Input
                    type="text"
                    value={Order}
                    onChange={value => setOrder(value)}
                    required />
            </div>
            <div>
                <label>عنوان</label>
                <rsuite.Input
                    type="text"
                    value={Title}
                    onChange={value => setTitle(value)}
                    required />
            </div>
            <div>
                <label>کلمات کلیدی</label>
                <rsuite.Input
                    type="text"
                    value={KeyWords}
                    onChange={value => setKeyWords(value)}
                />
            </div>
            <div>
                <label>توضیحات</label>
                <rsuite.Input
                    type="text"
                    value={Comment}
                    onChange={value => setComment(value)}
                />
            </div>
            <div>
                <label>محتوا</label>
                <CKEditor initData={Content} data={Content} onChange={Content_Change}  onReady={editor => {
                    console.log('Editor is ready to use!');
                }}
                    config={{
                        autoGrow_maxHeight: 250,
                        language: "fa",
                        contentsLangDirection: "rtl",
                    }}
                />
            </div>
            <div>
                <label>URL</label>
                <rsuite.InputGroup>
                    <rsuite.Input
                        type="text"
                        value={URL}
                        onChange={value => setURL(value)}
                    />
                    <rsuite.InputGroup.Button onClick={AddURL}>
                        ثبت
                    </rsuite.InputGroup.Button>
                </rsuite.InputGroup>

            </div>
            <div className='pt-2'>
                {

                    URLs.map(item =>
                        <rsuite.Tag closable onClose={() => DeleteURL(item.url)}>{item.url}</rsuite.Tag>
                    )
                }
            </div>

            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?

                        <rsuite.Button appearance="primary" className="mt-2" onClick={handleSubmit}>
                            ثبت 
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>

        </form>
    );
});

export default TopicProp;